module.exports = __webpack_public_path__ + "assets/assets/images/icons/arrow-right.1c980f49.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/icons/arrow-right.svg
// module id = 241
// module chunks = 0